import {fabric} from 'fabric';

export abstract class AbstractShapeFactory {
  protected awType: string;
  protected shapeObject: any;
  protected parentButton: string;

  protected constructor() {

  }

  /**
     * Abstract method to be overridden and create and return concrete shape
     * at anchor points anchorX and anchorY
     */
  abstract create(anchorX: number, anchorY: number, color: string, fill: string, stroke: number): any;

  /**
     * Abstract method to be overridden and modify the created shape object
     * with event points eventX and eventY
     */
  abstract modify(anchorX: number, anchorY: number, eventX: number, eventY: number): void;

  /**
     * Abstract method to be overridden and copy and drop the created shape object
     */
  abstract copyAndDrop(id: number, awtype: string, callback: (clone) => void): void;

  /**
     * Clones the created shape object, sets the custom attributes 'id' and 'awtype' and executes
     * the callback function
     */
  protected copy(id: number, awtype: string, callback: (clone) => void): void {
    this.shapeObject.clone( (clone) => {
      clone.set('selectable', false);
      clone.toObject = (function (toObject) {
        return function () {
          return fabric.util.object.extend(toObject.call(this), {
            id: this.id,
            awtype: this.awtype
          });
        };
      })(clone.toObject);
      clone.id = id;
      clone.awtype = awtype;
      callback(clone);
    });
  }

  public getAWType(): string {
    return this.awType;
  }

  public getShapeObject(): string {
    return this.shapeObject;
  }

  public getParentButton(): string {
    return this.parentButton;
  }

}
